export const getInitialState = () => ({
    visible: false
});
